import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { formatCompact } from '@/lib/utils'

export function SeoPulse() {
  const { data } = useQuery({ queryKey: ['seo-pulse'], queryFn: api.seoPulse })

  return (
    <section className="border border-border rounded-md p-3 min-w-0">
      <div className="flex justify-between items-center mb-2.5">
        <h2 className="text-sm font-medium">SEO pulse</h2>
        <span className="text-[10px] text-ink-tertiary">GSC · 28d</span>
      </div>

      {data && (
        <>
          <div className="grid grid-cols-2 gap-2 mb-2.5">
            <div>
              <div className="text-[10px] text-ink-secondary">Impressions</div>
              <div className="text-sm font-medium">{formatCompact(data.impressions_28d)}</div>
              <div className="text-[10px] text-status-approved-accent">
                {data.impressions_delta_pct >= 0 ? '+' : ''}{data.impressions_delta_pct.toFixed(0)}%
              </div>
            </div>
            <div>
              <div className="text-[10px] text-ink-secondary">Avg position</div>
              <div className="text-sm font-medium">{data.avg_position.toFixed(1)}</div>
              <div className="text-[10px] text-status-approved-accent">
                {data.avg_position_delta > 0 ? '+' : ''}{data.avg_position_delta.toFixed(1)}
              </div>
            </div>
          </div>

          <div className="text-[10px] text-ink-tertiary uppercase tracking-wider mb-1.5">Top movers</div>
          <div className="flex flex-col gap-1">
            {data.top_movers.map((m) => (
              <div key={m.page} className="flex justify-between text-xs">
                <span className="text-ink-secondary truncate mr-2">{m.page}</span>
                <span className={m.delta_pct >= 0 ? 'text-status-approved-accent' : 'text-status-danger-accent'}>
                  {m.delta_pct >= 0 ? '+' : ''}{m.delta_pct}%
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  )
}
